import _ from 'lodash'

export const findNoteTemplate = (state) => (id) => {
  return state.loadedNoteTemplates[id]
}

export const getNoteTemplatesAsAry = (state) => {
  return _.values(state.noteTemplates)
}
